import * as $ from 'jquery';
import 'bootstrap';
import { adobeDataLayerWrapper } from "./adobeDataLayerMethod";

export class memberOnlineServices {
    private checkout: any = null;
    private ppid: any = null;
    private mopId: any = null;
    private isReady = false;
    private isError = false;
    private isRedirecting = false;
    private noFingerprint = false;
    private htmlSetting = true;
    private errorMessageArr = [
        {key: 'Network', message: "Oops, the connection was lost. Please refresh your page to try again."},
        {key: 'SessionTimeout', message: "Transaction session has been timed out. Please refresh your page to try again."},
        {key: 'PaymentError', message: "There was a Payment Error. Please try again."},
        {key: 'Canceled', message: "Transaction Cancelled by User​."},
        {key: 'Unexpected', message: "There was an unexpected error during transaction. Please try again."},
    ];

    initializeCheckoutSDk(): any {
        let self = this;
        const urlParams = new URLSearchParams(window.location.search);
        let res = JSON.parse(localStorage.getItem('online-services-data'));
        $('.price').html(res.postRedirectionValue);
		self.ppid = urlParams.get('ppid') ? urlParams.get('ppid'): urlParams.get('PPID');
        if(urlParams.get('PPID')) {
            self.loading(true, 'Thank you for your order. We are redirecting you...');
        } else {
            self.loading(true);
        }
        const environment = $('#environment').val();
        var SDKConfiguration = {
            container: 'payment-form-container',
            ppid: this.ppid,
            environment: environment,
            locale: 'en',
            options: {
                mopSelectionInSdk: false,
                showVendor: false,
                collectCardholderName: false
            }
        }
        self.checkout = new window.AmadeusCheckout(SDKConfiguration);
        self.checkout.onReady = function(mopsList: any, sessionTimeout: any) {
            console.log("onReady", mopsList, sessionTimeout);
            localStorage.setItem('cardList', JSON.stringify(mopsList));
            $('#overlay').fadeOut();
            if (!this.isError) {
                $('#payment-form').fadeIn();
                $('#overlay').fadeOut();
                self.loadMOPS(mopsList);
                this.isReady = true;
                self.checkout.selectMop('creditcard');
            }
        }

        self.checkout.onChange = function(change: any) {
            console.log("onChange", change);
            if(change && change.cardBin) {
                localStorage.setItem('cardBin', change.cardBin.vendor);
            }
            if (this.isReady && !this.isRedirecting) {
                self.loading(change.isLoading);
            }
            $('input.btn-pay').prop('disabled', !change.isValid);
        }
        self.checkout.onRedirectionNeeded = function(mopId: any, redirectionRequest: any) {
            // Called before the SDK redirects the user to an external page
            console.log("onRedirectionNeeded", mopId, redirectionRequest);
            this.isRedirecting = true;
        }
        self.checkout.onSuccess = function(mopId: any) {
            // Called when the payment is successful
            console.log("onSuccess", mopId);
            // clearInterval();
            let url = window.location.href.split('/');
            window.location.href = "https://" + window.location.hostname + "/" +url[3]+ "/" + url[4] + "/enrich-portal/home/online-services/online-services-response.html?ppid=" + self.ppid + "&mopId=" + mopId + "&status=success";
        }
        self.checkout.onError = function(mopId: any, errorDetails: any) {
            if(errorDetails.nextAction == "Retry") {
                self.loading(true, 'Thank you for your order. We are redirecting you...');
            } else {
                self.loading(true);
            }
            self.mopId = mopId;
            if(errorDetails.nextAction && errorDetails.nextAction == "Retry") {
                let errorMessage = self.errorMessageArr.filter((error) => {
                    return error.key === errorDetails.errorType;
                });
                self.loading(false);
                $('body').addClass("body-class");
                $('#enrich-nav-sidebar').addClass('sidebar-none-events');
                $('#bookingNav').addClass("sidebar-none-events");
                localStorage.setItem('errorMsg', errorMessage[0].message);
                $('#payment-status').html(errorMessage[0].message);
                $('#checkout-retry-modal').removeClass('hideclass');
                $('#checkout-retry-modal').addClass('showclass');
            }
        }
        $('.cancel-btn').click(function() {
            $('body').removeClass("body-class");
            $('#bookingNav').removeClass("sidebar-none-events");
            $('#enrich-nav-sidebar').removeClass('sidebar-none-events');
            // clearInterval();
            let url = window.location.href.split('/');
            window.location.href = "https://" + window.location.hostname + "/" +url[3]+ "/" + url[4] + "/enrich-portal/home/online-services/online-services-response.html?ppid=" + self.ppid + "&mopId=" + self.mopId + "&status=error";
        })
        $('.proceed-btn').click(function() {
            $('body').removeClass("body-class");
            $('#bookingNav').removeClass("sidebar-none-events");
            $('#enrich-nav-sidebar').removeClass('sidebar-none-events');
            $('#checkout-retry-modal').removeClass('showclass');
            $('#checkout-retry-modal').addClass('hideclass');
        });
        $('.btn-pay').click(function() {
            adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich - Point Services - Reactivate Your Enrich Points',
                'clickName': 'click:btn-click:point-services-payment-purchase',
                'componentType': 'btn',
                'componentName': 'Payment Button',
                'componentID': '',
                'attributes': []
            });
            self.checkout.pay();
        });
        $('.btn-cancel').click(function(event: any) {
            event.preventDefault();
            // clearInterval();
            let url = window.location.href.split('/');
            window.location.href = "https://" + window.location.hostname + "/" +url[3]+ "/" + url[4] + "/enrich-portal/home/online-services/online-services-response.html?ppid=" + self.ppid + "&mopId=" + self.mopId + "&status=error&cancel=true";
        });
        self.checkout.start();
    }
    loadMOPS(mopsList: any) {
        // load creditcard form
        let html = `<div style="margin-top: 3px;">Important</div>
        <ul>
            <li>Please disable the pop-up blocker before proceeding with payment</li>
            <li>Please complete your payment within 10 minutes before session time-out</li>
            <li>Do not refresh this page or click "Back" as this will interrupt your transaction</li>
            <li>You will be redirected to Malaysia Airlines' confirmation page when payment is successful</li>
        </ul>`;
        let self = this;
        for (var mop of mopsList) {
            var name = mop.name;
            var id = mop.id;
            var icon_url = this.checkout.getIconUrl('amop', mop.name);
            console.log(icon_url);
            switch (name) {
                case "label_mop_creditcard":
                    $("#creditcard").val(id);
                    this.checkout.create('payment-form-container', id);
                case "label_amop_maybank":
                    $("#maybank").val(id);
                    $("#maybank + .radio__label").html('<img src="' + icon_url + '" />');
                    this.checkout.create('amop_container', id);
                    break;
                case "label_amop_cimbclicks":
                    $("#cimbclicks").val(id);
                    $("#cimbclicks + .radio__label").html('<img src="' + icon_url + '" />');
                    this.checkout.create('amop_container', id);
                    break;
                case "label_amop_fpx":
                    $("#fpx").val(id);
                    $("#fpx + .radio__label").html('<img src="' + icon_url + '" />');
                    this.checkout.create('amop_container', id);
                    break;
                case "label_amop_grabpay":
                    $("#grabpay").val(id);
                    $("#grabpay + .radio__label").html('<img src="' + icon_url + '" />');
                    this.checkout.create('amop_container', id);
                    break;
                case "label_amop_boost":
                    $("#boost").val(id);
                    $("#boost + .radio__label").html('<img src="' + icon_url + '" />');
                    this.checkout.create('amop_container', id);
                    break;
                case "label_amop_touchngo":
                    $("#touchngo").val(id);
                    $("#touchngo + .radio__label").html('<img src="' + icon_url + '" />');
                    this.checkout.create('amop_container', id);
                    break;
                case "label_amop_paypal":
                    $("#paypal").val(id);
                    $("#paypal + .accordion__label .accordion__icon").html('<img src="' + icon_url + '" />');
                    $("#paypal + .accordion__label span").html('');
                    this.checkout.create('amop_container', id);
                    break;
                case "label_amop_installmentpayment":
                    $("#instalment").val(id);
                    $("#instalment + .accordion__label .accordion__icon").html('<img src="' + icon_url + '" />');
                    $("#instalment + .accordion__label span").html(mop.displayableName);
                    this.checkout.create('amop_container', id);
                    break;
                default:
                    break;
            }
        }
        $('input:radio[name=payment_options], input:radio[name=ewalletselection], input:radio[name=onlinebankingselection]').change(function() {
            if(self.htmlSetting) {
                $($($($('div #online_banking')[0].parentElement).children()[2]).children()[0]).html(html);
                $($($($('div #ewallet')[0].parentElement).children()[2]).children()[0]).html(html);
                self.htmlSetting = false;
            }
            if (this.id === 'online_banking') {
                var value = $('input:radio[name=onlinebankingselection]:checked').val();
                if (!value) {
                    var firstOption = $('input:radio[name=onlinebankingselection]:first')
                    firstOption.prop('checked', true);
                    value = firstOption.val();
                }
                console.log('selecting method of payment', value);
                self.checkout.selectMop(value);
            } else if (this.id === 'ewallet') {
                var value = $('input:radio[name=ewalletselection]:checked').val();
                if (!value) {
                    var firstOption = $('input:radio[name=ewalletselection]:first')
                    firstOption.prop('checked', true);
                    value = firstOption.val();
                }
                console.log('selecting method of payment', value);
                self.checkout.selectMop(value);

            } else {
                console.log('selecting method of payment', this.value);
                self.checkout.selectMop(this.value);
            }
            console.log(self);
        });
    }
    loading(isLoading: any, text:any=null) {
        text = text === null ? 'Thank you for your order. We are redirecting you...' : text;
        console.log(isLoading);
        if (isLoading) {
            $('.loader-desc').html(text);
            $('#overlay').fadeIn();
            $('.content').addClass('hideclass');
            $('.content').removeClass('showclass');
            $('.footer').addClass('hideclass');
            $('.footer').removeClass('showclass');
            $('#overlay').addClass('showclass');
            $('#overlay').removeClass('hideclass');
        } else {
            $('#overlay').fadeOut();
            $('.footer').addClass('showclass');
            $('.footer').removeClass('hideclass');
            $('.content').addClass('showclass');
            $('.content').removeClass('hideclass');
            $('#overlay').addClass('hideclass');
            $('#overlay').removeClass('showclass');
        }
    }
}

let scope:Element = document.querySelector('#checkout-online-services');
declare const window: any;

if (scope) {
	try {
	let memberOnlineService = new memberOnlineServices();
    var adobeDataLayer = new adobeDataLayerWrapper();
        adobeDataLayer.push('pageLoaded', {
            'pageName': '',
            'pageType': 'Enrich - Point Services - Payment',
            'attributes': []
        });
    if(checkAmadeusCheckoutIsLoaded()) {
        memberOnlineService.initializeCheckoutSDk();
    } else {
        setTimeout(function() {
            checkAmadeusCheckoutIsLoaded()
        }, 1000);
    }
	} catch(e) {console.error(e);}
}
function checkAmadeusCheckoutIsLoaded() {
    return window && window.AmadeusCheckout;
}	

